import { TopDestinations } from './actionTypes';

const initialState = {
    initial: true,
    isFetching: false,
    topDestinations: [],
};

const requestTopDestinations = (state) => {
    return {
        ...state,
        initial: false,
        isFetching: true,
    };
};

const receiveTopDestinations = (state, { topDestinations }) => {
    return {
        ...state,
        isFetching: false,
        topDestinations,
    };
};

export default function(state = initialState, action) {
    switch (action.type) {
        case TopDestinations.REQUEST_TOP_DESTINATIONS:
            return requestTopDestinations(state);
        case TopDestinations.RECEIVE_TOP_DESTINATIONS:
            return receiveTopDestinations(state, action);
    }
    return state;
}
